import { render, staticRenderFns } from "./AddAditionalNote.vue?vue&type=template&id=4a2f4a93"
import script from "./AddAditionalNote.vue?vue&type=script&lang=js"
export * from "./AddAditionalNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports